/* eslint-disable no-unused-vars */
import vhCheck from 'vh-check';
import { isTouch } from './_helpers';
import { setDevice } from './_utilities/devices';
import { setResizeEvent, setDeviceType } from './utils';
import './core';
import Carousels from './_modules/carousels';
import InfiniteArticle from './_modules/infinite-article';
import Header from './_components/03-organisms/header-dropdown/header';
import HeaderMM from './_components/03-organisms/header-megamenu/header-megamenu';
import Search from './_components/03-organisms/search-dropdown/search';

vhCheck();

!isTouch && document.body.classList.add('no-touch');
isTouch && document.body.classList.add('is-touch');

// set resize custom event
setResizeEvent();
setDeviceType();
setDevice();

const HEADER = new Header();
const HEADERMM = new HeaderMM();
const CAROUSELS = new Carousels();
const INFINITEARTICLE = new InfiniteArticle();
const SEARCH = new Search();
